import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e155b532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-d-flex p-jc-around p-ai-center p-flex-wrap" }
const _hoisted_3 = { class: "p-inputgroup p-col-12 p-md-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1))
const _hoisted_5 = { class: "p-col-12 p-md-4" }

import { computed, ref } from "vue";
import { useFindAllCategories } from "@/graphql/category/find.all.categories";
import { getImage, makeTreeTable } from "@/graphql/utils/utils";
import CategoryForm from "@/components/category/CategoryForm.vue";
import { useI18n } from "vue-i18n";
import { subscriptionExpired } from "@/plugins/i18n";
import { useRemoveCategory } from "@/graphql/category/remove.category";
import { Category, EAccessMenu } from "@/graphql/types";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {

const { t } = useI18n();
const dialogUpdate = ref(false);
const listMode = ref(true);
const { loadRemove, submitRemove } = useRemoveCategory();
const { categories, loading } = useFindAllCategories();
const selectedCategory = ref<Category>(null);
const filters = ref({});
const expired = Boolean(subscriptionExpired());
const params = computed(() => {
  const acc = getAccess(EAccessMenu.Category);
  const noRestriction = canNavigateAnywhere();
  return {
    parents: makeTreeTable(categories.value, listMode.value ? 1 : 2),
    controls: [
      {
        label: t("modify"),
        icon: "pi pi-pencil",
        command: () => (dialogUpdate.value = true),
        disabled: !(acc?.update || noRestriction) || expired,
      },
      {
        label: t("remove"),
        icon: "pi pi-trash",
        command: () => {
          submitRemove(selectedCategory.value.id);
        },
        disabled: !(acc?.delete || noRestriction) || expired,
      },
    ],
    canCreate: (acc?.create || noRestriction) && !expired,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_TieredMenu = _resolveComponent("TieredMenu")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TreeTable = _resolveComponent("TreeTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TieredMenu, {
      id: "overlay_tmenu",
      ref: "tcontrols",
      model: params.value.controls,
      popup: true
    }, null, 8, ["model"]),
    _createElementVNode("div", _hoisted_1, [
      (params.value.canCreate)
        ? (_openBlock(), _createBlock(CategoryForm, {
            key: 0,
            categories: [..._unref(categories)],
            class: "p-col-12 p-md-4"
          }, null, 8, ["categories"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["p-col-12", { 'p-md-8': params.value.canCreate }])
      }, [
        _createVNode(_component_TreeTable, {
          loading: _unref(loading),
          rows: params.value.parents.length,
          value: params.value.parents,
          responsiveLayout: "scroll",
          "filter-mode": "lenient",
          filters: filters.value,
          class: "p-treetable-sm"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputText, {
                  modelValue: filters.value['global'],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['global']) = $event)),
                  placeholder: _ctx.$t('category.search')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ToggleButton, {
                  class: "p-col-12",
                  modelValue: listMode.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listMode).value = $event)),
                  onLabel: _ctx.$t('category.listUnMasked'),
                  offLabel: _ctx.$t('category.listMasked'),
                  onIcon: "pi pi-eye",
                  offIcon: "pi pi-eye-slash"
                }, null, 8, ["modelValue", "onLabel", "offLabel"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "label",
              header: _ctx.$t('category.name'),
              expander: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              headerClass: "sm-invisible",
              bodyClass: "sm-invisible",
              field: "image",
              header: _ctx.$t('image')
            }, {
              body: _withCtx(({ node }) => [
                (node.data.image)
                  ? (_openBlock(), _createBlock(_component_Image, {
                      key: 0,
                      src: _unref(getImage)(node.data.image, 'categories'),
                      height: 50,
                      preview: ""
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_Avatar, {
                      key: 1,
                      label: node.data.label[0],
                      size: "large"
                    }, null, 8, ["label"]))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              headerClass: "sm-invisible",
              bodyClass: "sm-invisible",
              field: "createdAt",
              header: "Date de création"
            }, {
              body: _withCtx(({ node }) => [
                _createTextVNode(_toDisplayString(_ctx.$d(node.data.createdAt)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: _ctx.$t('controls')
            }, {
              body: _withCtx(({ node }) => [
                _createVNode(_component_Button, {
                  "aria-haspopup": "true",
                  "aria-controls": "overlay_tmenu",
                  icon: `pi pi-${_unref(loadRemove) ? 'spinner' : 'ellipsis-v'}`,
                  class: "p-button-text p-button-rounded",
                  onClick: ($event: any) => {
                selectedCategory.value = node.data;
                (_ctx.$refs['tcontrols'] as any).toggle($event);
              },
                  disabled: _unref(expired)
                }, null, 8, ["icon", "onClick", "disabled"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["loading", "rows", "value", "filters"])
      ], 2)
    ]),
    _createVNode(_component_Dialog, {
      breakpoints: { '960px': '96vw' },
      style: { width: '40vw' },
      header: _ctx.$t('update.title'),
      visible: dialogUpdate.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((dialogUpdate).value = $event))
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(CategoryForm, {
          modelValue: dialogUpdate.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogUpdate).value = $event)),
          item: selectedCategory.value,
          categories: [..._unref(categories)],
          src: _unref(getImage)(selectedCategory.value?.image, 'categories')
        }, null, 8, ["modelValue", "item", "categories", "src"])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}
}

})